<template>
  <div>
    <c-search-box @enter="getHeader">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            type="year"
            default="today"
            label="기준년도"
            name="wasteYear"
            v-model="searchParam.wasteYear"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="월별 폐기물 처리량/생산량 목록"
          tableId="processManual"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="등록" v-if="editable" icon="add" @btnClicked="linkClick" />
              <c-btn label="검색" icon="search" @btnClicked="getHeader" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'waste-report-manage',
  data() {
    return {
      grid: {
        columns: [
        ],
        data: [],
      },
      searchParam: {
        wasteYear: '',
        plantCd: null,
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '50%',
        top: '',
        param: {},
        closeCallback: null,
      },
      headerUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.waste.volume.list.url;
      this.headerUrl = selectConfig.env.waste.mst.list.url;
      this.getHeader();
    },
    getHeader() {
      this.$http.url = this.headerUrl;
      this.$http.type = 'GET';
      this.$http.param = {useFlag: 'Y', plantCd: this.searchParam.plantCd};
      this.$http.request((_result) => {
        let _cols = [];
        this.$_.forEach(_result.data, _item => {
          _cols.push({
            id: 'datas',
            name: _item.envWasteMstId,
            field: _item.envWasteMstId,
            label: _item.envWasteMstName,
            align: 'right',
            type: 'cost',
            style: 'width:100px',
            sortable: true,
          });
        })
        this.grid.columns = [
          {
            id: 'original',
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'wasteYm',
            field: 'wasteYm',
            label: '기준월',
            align: 'center',
            type: 'link',
            style: 'width: 80px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'wasteTransport',
            field: 'wasteTransport',
            type: 'cost',
            label: '폐기물 운반횟수',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'salesVolume',
            field: 'salesVolume',
            type: 'cost',
            label: '생산량(kg)',
            align: 'right',
            style: 'width: 120px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'wasteUnit',
            field: 'wasteUnit',
            type: 'cost',
            label: '처리단가(원)',
            style: 'width: 120px',
            align: 'right',
            sortable: true,
          },
          {
            id: 'original',
            name: 'wasteCost',
            field: 'wasteCost',
            type: 'cost',
            label: '처리비용(원)',
            style: 'width: 120px',
            align: 'right',
            sortable: true,
          },
        ]
        if (_cols.length > 0) {
          this.grid.columns.push(
            {
              name: 'volume',
              field: 'volume',
              label: '폐기물 처리량(kg)',
              align: 'center',
              child: _cols
            }
          )
        }
        this.getList();
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./wasteVolumnDetail.vue"}`);
      this.popupOptions.title = '폐기물 발생량/판매량 상세';
      this.popupOptions.param = {
        envWasteVolumeId: result ? result.envWasteVolumeId : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
